export const DELETE_COURSE_ACTION = "deleteCourseAct";
